import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarCloudSettings" */ './lazyIndex')
);

export const lazySaveCalendarCloudSettings = new LazyAction(
    lazyModule,
    m => m.saveCalendarCloudSettings
);

export const lazyInitCalendarCloudSettings = new LazyAction(
    lazyModule,
    m => m.initCalendarCloudSettings
);

export { CalendarCloudSettings } from './store/schema/CalendarCloudSettings';
export { isCalendarCloudSettingsInitialized } from './utils/isCalendarCloudSettingsInitialized';
export { getEffectiveShouldEventsEndEarly } from './selectors/getEffectiveShouldEventsEndEarly';
export { getEffectiveEndShortEventsBy } from './selectors/getEffectiveEndShortEventsBy';
export { getEffectiveEndLongEventsBy } from './selectors/getEffectiveEndLongEventsBy';
export { getEffectiveEnableOnlineMeetingsByDefault } from './selectors/getEffectiveEnableOnlineMeetingsByDefault';
